import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth-context";
import AppLayout from "@/components/AppLayout";

// Public pages (no navbar)
import LandingPage from "@/pages/LandingPage";
import SignInPage from "@/pages/SignInPage";
import RegisterPage from "@/pages/RegisterPage";
import JoinEventPage from "@/pages/JoinEventPage";
import VerifyEmailPage from "@/pages/VerifyEmailPage";
import VerifyPhonePage from "@/pages/VerifyPhonePage";
import LookbookViewerPage from "@/pages/LookbookViewerPage";

// Authenticated pages (with navbar via AppLayout)
import HostDashboardPage from "@/pages/HostDashboardPage";
import CreateEventPage from "@/pages/CreateEventPage";
import EventCreatedPage from "@/pages/EventCreatedPage";
import EventPreviewPage from "@/pages/EventPreviewPage";
import EventJoinedPage from "@/pages/EventJoinedPage";
import ContribEventPage from "@/pages/ContribEventPage";
import ContribUploadPage from "@/pages/ContribUploadPage";
import HostReviewPage from "@/pages/HostReviewPage";
import HostLookbookPage from "@/pages/HostLookbookPage";
import HostLookbookLivePage from "@/pages/HostLookbookLivePage";
import HostLookbookPreviewPage from "@/pages/HostLookbookPreviewPage";
import HostLookbookLaunchPage from "@/pages/HostLookbookLaunchPage";
import HostVaultPage from "@/pages/HostVaultPage";
import HostGuestsPage from "@/pages/HostGuestsPage";
import HostApprovalPage from "@/pages/HostApprovalPage";
import FramesPage from "@/pages/FramesPage";
import FrameCollectionPage from "@/pages/FrameCollectionPage";
import MyViewsPage from "@/pages/MyViewsPage";
import NotificationsPage from "@/pages/NotificationsPage";
import SettingsPage from "@/pages/SettingsPage";
import VerifyAttendancePage from "@/pages/VerifyAttendancePage";
import HostPremiumPage from "@/pages/HostPremiumPage";
import PremiumSuccessPage from "@/pages/PremiumSuccessPage";
import PremiumCancelPage from "@/pages/PremiumCancelPage";
import ProSuccessPage from "@/pages/ProSuccessPage";
import ProCancelPage from "@/pages/ProCancelPage";
import ProReferralsPage from "@/pages/ProReferralsPage";
import ProClientsPage from "@/pages/ProClientsPage";
import TransferInboxPage from "@/pages/TransferInboxPage";
import ProAnalyticsPage from "@/pages/ProAnalyticsPage";
import ProTeamPage from "@/pages/ProTeamPage";
import TeamInvitesPage from "@/pages/TeamInvitesPage";
import AdminSuppressionsPage from "@/pages/AdminSuppressionsPage";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public routes — no Navbar */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/sign-in" element={<SignInPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/join" element={<JoinEventPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/verify-phone" element={<VerifyPhonePage />} />
          <Route path="/lookbook/:token" element={<LookbookViewerPage />} />
          <Route path="/premium/success" element={<PremiumSuccessPage />} />
          <Route path="/premium/cancel" element={<PremiumCancelPage />} />
          <Route path="/pro/success" element={<ProSuccessPage />} />
          <Route path="/pro/cancel" element={<ProCancelPage />} />

          {/* Authenticated routes — AppLayout adds Navbar + bottom tabs */}
          <Route element={<AppLayout />}>
            <Route path="/host-dashboard" element={<HostDashboardPage />} />
            <Route path="/create-event" element={<CreateEventPage />} />
            <Route path="/event-created" element={<EventCreatedPage />} />
            <Route path="/event-preview" element={<EventPreviewPage />} />
            <Route path="/event-joined" element={<EventJoinedPage />} />
            <Route path="/contrib-event" element={<ContribEventPage />} />
            <Route path="/contrib-upload" element={<ContribUploadPage />} />
            <Route path="/host-review" element={<HostReviewPage />} />
            <Route path="/host-lookbook" element={<HostLookbookPage />} />
            <Route path="/host-lookbook-live" element={<HostLookbookLivePage />} />
            <Route path="/host-lookbook-preview" element={<HostLookbookPreviewPage />} />
            <Route path="/host-lookbook-launch" element={<HostLookbookLaunchPage />} />
            <Route path="/host-vault" element={<HostVaultPage />} />
            <Route path="/host-guests" element={<HostGuestsPage />} />
            <Route path="/host-approval-required" element={<HostApprovalPage />} />
            <Route path="/frames" element={<FramesPage />} />
            <Route path="/frame-collection" element={<FrameCollectionPage />} />
            <Route path="/my-views" element={<MyViewsPage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/verify-attendance" element={<VerifyAttendancePage />} />
            <Route path="/host-premium" element={<HostPremiumPage />} />
            <Route path="/pro-referrals" element={<ProReferralsPage />} />
            <Route path="/pro-clients" element={<ProClientsPage />} />
            <Route path="/transfer-inbox" element={<TransferInboxPage />} />
            <Route path="/pro-analytics" element={<ProAnalyticsPage />} />
            <Route path="/pro-team" element={<ProTeamPage />} />
            <Route path="/team-invites" element={<TeamInvitesPage />} />
            <Route path="/admin/suppressions" element={<AdminSuppressionsPage />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
